import React from 'react';
import { Stack, SxProps, Typography } from '@mui/material';
import { headingFontBold, vars } from '../../../../Theme';

const labelSx: SxProps = {
    ...headingFontBold,
    color: vars.font,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 'normal',
    pr: '4px',
};

const captionSx: SxProps = {
    ...headingFontBold,
    color: vars.font,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
};

export default ({ label, caption, stackSx: overrideStackSx }: ILabelAndCaptionProps) => (
    <Stack sx={{ m: '16px 0px 12px 0px', ...overrideStackSx }}>
        <Typography sx={labelSx}>{label}</Typography>
        <Typography sx={captionSx}>{caption}</Typography>
    </Stack>
);

interface ILabelAndCaptionProps {
    label: string;
    caption: string;
    stackSx?: SxProps;
}
